// language=GraphQL
export const ALL_FORMS_QUERY = `query Query($withFields: Boolean = false, $withFieldsOptions: Boolean = false, $withFieldsVisibilityConfig: Boolean = false, $withFieldsVisibilityConfigPricingTravels: Boolean = false) {
  forms: allCustomBookingForm {
    id
    fields @include(if: $withFields) {
      id
      inputType
      name
      label
      info
      value
      required
      options @include(if: $withFieldsOptions) {
        id
        value
        label
      }
      visibilityConfig @include(if: $withFieldsVisibilityConfig) {
        id
        pricingTravels @include(if: $withFieldsVisibilityConfigPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_FORM_QUERY = `query Query($id: ID!, $withFields: Boolean = false, $withFieldsOptions: Boolean = false, $withFieldsVisibilityConfig: Boolean = false, $withFieldsVisibilityConfigPricingTravels: Boolean = false) {
  form: customBookingForm(id: $id) {
    id
    fields @include(if: $withFields) {
      id
      inputType
      name
      label
      info
      value
      required
      options @include(if: $withFieldsOptions) {
        id
        value
        label
      }
      visibilityConfig @include(if: $withFieldsVisibilityConfig) {
        id
        pricingTravels @include(if: $withFieldsVisibilityConfigPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_FORM_MUTATION = `
  mutation Mutation($input: CreateCustomBookingFormInput, $withFields: Boolean = false, $withFieldsOptions: Boolean = false, $withFieldsVisibilityConfig: Boolean = false, $withFieldsVisibilityConfigPricingTravels: Boolean = false) {
    form: createCustomBookingForm(input: $input) {
      id
      fields @include(if: $withFields) {
        id
        inputType
        name
        label
        info
        value
        required
        options @include(if: $withFieldsOptions) {
          id
          value
          label
        }
        visibilityConfig @include(if: $withFieldsVisibilityConfig) {
          id
          pricingTravels @include(if: $withFieldsVisibilityConfigPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_FORM_MUTATION = `
  mutation Mutation($input: UpdateCustomBookingFormInput, $withFields: Boolean = false, $withFieldsOptions: Boolean = false, $withFieldsVisibilityConfig: Boolean = false, $withFieldsVisibilityConfigPricingTravels: Boolean = false) {
    form: updateCustomBookingForm(input: $input) {
      id
      fields @include(if: $withFields) {
        id
        inputType
        name
        label
        info
        value
        required
        options @include(if: $withFieldsOptions) {
          id
          value
          label
        }
        visibilityConfig @include(if: $withFieldsVisibilityConfig) {
          id
          pricingTravels @include(if: $withFieldsVisibilityConfigPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_FORM_MUTATION = `
  mutation Mutation($input: DeleteCustomBookingFormInput) {
    deleteCustomBookingForm(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_FORM_MUTATION = `
  mutation Mutation($input: DeleteCustomBookingFormInput) {
    forceDeleteCustomBookingForm(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_FORM_FIELDS_MUTATION = `
  mutation Mutation($input: addCustomBookingFormFieldsInput) {
    addCustomBookingFormFields(input: $input) {
      id
      fieldIds
    }
  }`

// language=GraphQL
export const REMOVE_FORM_FIELDS_MUTATION = `
  mutation Mutation($input: removeCustomBookingFormFieldsInput) {
    removeCustomBookingFormFields(input: $input) {
      id
      fieldIds
    }
  }`

// language=GraphQL
export const CREATE_FORM_FIELDS_MUTATION = `
  mutation Mutation($input: createCustomBookingFormFieldsInput) {
    createCustomBookingFormFields(input: $input) {
      id
      fieldIds
    }
  }`

// language=GraphQL
export const DELETE_FORM_FIELDS_MUTATION = `
  mutation Mutation($input: deleteCustomBookingFormFieldsInput) {
    deleteCustomBookingFormFields(input: $input) {
      id
      fieldIds
    }
  }`

// language=GraphQL
export const UPDATE_FORM_FIELDS_ORDER_MUTATION = `
  mutation Mutation($input: updateCustomBookingFormFieldsOrderInput) {
    updateCustomBookingFormFieldsOrder(input: $input) {
      id
      fieldIds
    }
  }`

// language=GraphQL
export const FORMS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricingCustomDataConfigs: Boolean = false) {
  groupedDependents: customBookingFormDependents(id: $id) {
    travelPricingCustomDataConfigs @include(if: $withTravelPricingCustomDataConfigs) {
      id
      useTravellerForm
      useBookingForm
    }
  }
}`
